export const getModKeyLabel = (): string =>
  navigator.platform.includes("Mac") ? "⌘" : "Ctrl";
